<template>
  <div class="cert-list-item">
    <CertificationTile
      :key="certification.id"
      :certification="certification"
      :showDetails="false"
    />
    <div class="cert-list-item__subtext-wrapper">
      <p class="cert-list-item__subtext">
        Awarded: {{ formatDate(certification.awarded) }}
      </p>
      <div @click="showAttemptScore" class="cert-list-item__exam-link">
        Exam results
      </div>
    </div>
    <router-link
      :to="{
        name: 'certificate-verified',
        params: { attemptId: certification.attempt_id },
      }"
      class="btn btn--secondary cert-list-item__button"
    >
      Go to certification
    </router-link>
  </div>
</template>

<script>
import { format } from 'date-fns-tz'
import CertificationTile from '@/components/certifications/CertificationTile.vue'

export default {
  name: 'CertificationListItem',
  components: {
    CertificationTile,
  },
  props: {
    certification: {
      type: Object,
      required: true,
    },
    attempt: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  methods: {
    formatDate(date) {
      return format(new Date(date), 'LLL d, yyyy')
    },
    showAttemptScore() {
      this.$store.dispatch(
        'certifications/setCurrentAttemptScored',
        this.attempt
      )
    },
  },
}
</script>

<style lang="scss">
.cert-list-item {
  display: flex;
  flex-direction: column;
  background: var(--glass-mid-gray);
  mix-blend-mode: normal;
  border-radius: 10px;
  flex-grow: 1;
  flex-wrap: wrap;
  color: var(--white);
  position: relative;
  margin-bottom: 20px;
  @include tablet {
    margin: 0;
  }
  @include tablet {
    flex-wrap: nowrap;
    height: 436px;
    width: 460px;
  }
  &:hover {
    transition: 0.3s;
    background-color: rgb(255 255 255 / 5%);
    cursor: pointer;
  }
  &__badge-wrapper {
    width: 100%;
    @include tablet {
      width: auto;
    }
  }
  &__badge {
    height: 115px;
    width: 70px;
  }
  &__details-wrapper {
    padding: 30px 0 50px 0;
    @include tablet {
      padding: 0 30px 30px 30px;
    }
  }
  &__title {
    font-weight: 700;
    font-size: rem(20);
    line-height: 26px;
    padding: 0;
    margin: 0;
    display: flex;
    width: 100%;
    @include tablet {
      max-width: 85%;
    }
  }
  &__version {
    position: absolute;
    right: 20px;
    top: 30px;
  }
  &__subtext {
    color: var(--light-blue-gray);
    font-size: rem(16);
    line-height: 20px;
    padding: 0px 30px;
    margin: 0;
  }

  &__exam-link {
    color: var(--light-blue-gray);
    font-size: rem(16);
    line-height: 20px;
    padding: 0px 30px;
    margin: 0;
    text-decoration: underline;
    text-underline-offset: 20%;
  }
  &__link-wrapper {
    position: absolute;
    bottom: 30px;
    right: 30px;
    &:hover {
      opacity: 0.8;
    }
  }
  &__user-status {
    top: 0px;
    left: 0px;
    position: absolute;
  }
  &__button {
    align-self: flex-end;

    @include tablet {
      margin-right: 6.5%;
    }
  }
}
.certification-tile {
  width: 100% !important;
  background: transparent !important;
  &__badge {
    max-height: 63% !important;
  }
  &__badge-logo {
    height: 200px !important;
    position: relative;
    top: -20%;
  }
  &__title {
    margin-top: 10px !important;
    margin-bottom: 0px !important;
  }
  &__wrapper {
    padding: 0px 30px !important;
  }
}
</style>
